module.exports = __webpack_public_path__ + "img/p007.2586d34e.png";